import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const MarketingLayout = ({ children }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="marketing-wrapper">
      {/* Navigation */}
      <nav className="nav">
        <div className="container nav-content">
          <Link to="/" className="nav-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_volunteer-hub-35/artifacts/5ta1s578_playback%20logo.jpg" 
              alt="PlayBack Token Logo" 
              style={{width: '50px', height: '50px'}} 
            />
            <span className="brand-font">PlayBack Token</span>
          </Link>
          <div className="nav-links">
            <Link to="/" className={`nav-link-item ${isActive('/') ? 'active' : ''}`}>Home</Link>
            <Link to="/clubs" className={`nav-link-item ${isActive('/clubs') ? 'active' : ''}`}>For Clubs</Link>
            <Link to="/companies" className={`nav-link-item ${isActive('/companies') ? 'active' : ''}`}>For Companies</Link>
            <Link to="/login" className="btn btn-outline">Login to App</Link>
          </div>
          <button 
            className="mobile-menu-btn" 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'active' : ''}`}>
        <Link to="/" className={isActive('/') ? 'active' : ''} onClick={() => setMobileMenuOpen(false)}>Home</Link>
        <Link to="/clubs" className={isActive('/clubs') ? 'active' : ''} onClick={() => setMobileMenuOpen(false)}>For Clubs</Link>
        <Link to="/companies" className={isActive('/companies') ? 'active' : ''} onClick={() => setMobileMenuOpen(false)}>For Companies</Link>
        <Link to="/login" onClick={() => setMobileMenuOpen(false)}>Login</Link>
      </div>

      {/* Page Content */}
      {children}

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <p>Verifying volunteer impact, one hour at a time.</p>
            </div>
            
            <div className="footer-links">
              <div className="footer-column">
                <h4>Platform</h4>
                <Link to="/clubs">For Clubs</Link>
                <Link to="/companies">For Companies</Link>
              </div>
              
              <div className="footer-column">
                <h4>Legal</h4>
                <Link to="/privacy">Privacy Policy</Link>
                <Link to="/terms">Terms of Service</Link>
              </div>
            </div>
          </div>
          
          <div className="footer-bottom">
            <p>&copy; 2025 PlayBack Token. All rights reserved. <span style={{marginLeft: '20px'}}>info@playbacktoken.com</span></p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MarketingLayout;